<div class="vy-form">
  <form [formGroup]="controls" (keyup.enter)="sendFilters()">
    <div class="accordion-item_wrap" id="contactForm">
      <div class="vy-form">
        <div class="container">
          <div class="row">
            @for(filter of filterValues | async; track $index){
            <div class="col-md-12 col-sm-12 col-xs-12">
              @if (filter.options) {
              <vy-select
                [formControlName]="filter.filterName"
                [options]="filter.options"
                autocomplete="off"
                [label]="filter.label | translate"
              ></vy-select>
              }@else {
              <vy-input
                [formControlName]="filter.filterName"
                [attrType]="filter.filterType"
                [label]="filter.label | translate"
              ></vy-input>
              }
            </div>
            }
          </div>
        </div>
      </div>
    </div>
  </form>

  <ng-container box-content>
    <div class="c2aEndSection">
      <div class="col-md-7 col-sm-12 col-xs-12">
        <vy-button
          label="booking_list_component.filters.submit_button"
          (click)="sendFilters()"
          onkeypress="sendFilters()"
          [isLoading]="false"
          [fullWidth]="true"
        ></vy-button>
        @if (isFilterActive()) {
        <div class="marginTop-m">
          <vy-text-link
            label="{{'booking_list_component.filters.remove_filters_button' | translate}}"
            (click)="deleteFilters()"
            onkeypress="deleteFilters()"
          ></vy-text-link>
        </div>
        }
      </div>
    </div>
  </ng-container>
</div>
